import type { ReactNode } from "react";
import { createContext, useContext } from "react";
import invariant from "tiny-invariant";

export interface TemplatePathContextValue {
  contentPath: string;
  editPath: string;
  visualBuilderPath: string;
}

const TemplatePathContext = createContext<TemplatePathContextValue | null>(
  null,
);
TemplatePathContext.displayName = "TemplatePathContext";

export const useEmailMarketingTemplatePaths = () => {
  const contextValue = useContext(TemplatePathContext);

  invariant(contextValue, "TemplatePathContext not found");

  return contextValue;
};

/**
 * Templates are used in Broadcast editor and Workflows. The content in both these surface areas have different paths.
 * This context is used to provide the paths to the UI area.
 */
export const MarketingEmailTemplatePathProvider = ({
  paths,
  children,
}: {
  paths: TemplatePathContextValue;
  children: ReactNode;
}) => (
  <TemplatePathContext.Provider value={paths}>
    {children}
  </TemplatePathContext.Provider>
);
